import { Link } from 'react-router-dom'
import Film from '../print-process/Film'
import { IconArrowRight } from '../ui/Icon'
import { SERVICE_ROUTES } from '../../data/services'
import './home-services.css'

/* The films start one after another, so the three never move in lockstep. */
const CASCADE_MS = 600

/**
 * Home services: the three services side by side on the moulded-black band,
 * each shown by its own station film. A tile is the service's title rule
 * (linking to its page), the looping film with its ruler and stations, the
 * service in a sentence and its capabilities as a legend. One section where
 * the page used to list the services three times (the hero's strip, the
 * services index and the film triptych). Anchor target of #services.
 *
 * @param {{
 *   lang?: 'tr' | 'en' | 'de',
 *   copy: {
 *     title: string,
 *     description: string,
 *     items: Array<{ key: 'pad' | 'screen' | 'assembly', name: string, description: string, features: string[] }>,
 *   },
 * }} props
 */
export default function HomeServices({ lang = 'tr', copy }) {
  return (
    <section id="services" className="hsv polymer" aria-labelledby="services-title">
      <div className="container">
        <header className="section-head hsv__head">
          <h2 id="services-title">{copy.title}</h2>
          <p>{copy.description}</p>
        </header>

        {/* No clipping reveal on an ancestor of the film (the film box only
            rises): a clip hides the film from the observers that mount and
            play it. */}
        <ul className="hsv__list" role="list">
          {copy.items.map((item, index) => {
            const to = SERVICE_ROUTES[item.key][lang]
            const nameId = `hsv-${item.key}-name`
            return (
              <li className="hsv__tile" key={item.key} style={{ '--i': index }}>
                <h3 className="hsv__title" data-reveal="">
                  <Link to={to} viewTransition className="hsv__link">
                    <span className="hsv__name" id={nameId}>
                      {item.name}
                    </span>
                    <span className="hsv__rule" aria-hidden="true" />
                    <IconArrowRight className="hsv__arrow" size={20} />
                  </Link>
                </h3>
                <div className="hsv__film" data-reveal="rise">
                  <Film variant={item.key} lang={lang} size="tile" delay={index * CASCADE_MS} labelledBy={nameId} />
                </div>
                <div className="hsv__text" data-reveal="">
                  <p className="hsv__desc">{item.description}</p>
                  <ul className="hsv__features legend" role="list">
                    {item.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
